module.exports = __webpack_public_path__ + "img/body-measurement.bc4241e5.svg";